import { mergeThemes } from "@whitespace/components";
import parentTheme from "@whitespace/gatsby-theme-smorgasbord/src/theme";

import childTheme from "../../../theme";

var theme = mergeThemes(parentTheme, childTheme);

export default theme;
